/*
 * Koshnika CRO — Q4 2026 (deferred, ~1.5KB unminified)
 *
 * 1. Ticker pause control (WCAG 2.2.2). The marquee moves for longer than
 *    5 seconds, so users need a way to stop it. State persists for the tab.
 * 2. Clarity release tag, so recordings/heatmaps can be split before/after
 *    each rollout step. Change RELEASE on every step of the rollout plan.
 *
 * No dependencies. Safe to load on every template. Re-runs cleanly when the
 * theme editor re-renders the header group.
 */
(function () {
  'use strict';

  var RELEASE = 'q4-step-1';
  var KEY = 'k-ticker-paused';

  function store(get, val) {
    try {
      if (get) return sessionStorage.getItem(KEY) === '1';
      sessionStorage.setItem(KEY, val ? '1' : '0');
    } catch (e) { /* private mode — ignore */ }
    return false;
  }

  var ICON_PAUSE = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path fill="currentColor" d="M4 2h3v12H4zM9 2h3v12H9z"/></svg>';
  var ICON_PLAY = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path fill="currentColor" d="M4 2l10 6-10 6z"/></svg>';

  function initTicker(root) {
    var ticker = (root || document).querySelector('.kut');
    if (!ticker || ticker.querySelector('.kut__pause')) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var inner = ticker.querySelector('.kut__inner') || ticker;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kut__pause';

    function render(paused) {
      ticker.classList.toggle('is-paused', paused);
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements');
      btn.innerHTML = paused ? ICON_PLAY : ICON_PAUSE;
    }

    btn.addEventListener('click', function () {
      var next = !ticker.classList.contains('is-paused');
      store(false, next);
      render(next);
    });

    render(store(true));
    inner.appendChild(btn);
  }

  function tagClarity() {
    if (typeof window.clarity === 'function') {
      window.clarity('set', 'k_release', RELEASE);
    }
  }

  function boot() {
    initTicker();
    tagClarity();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor: header group re-renders replace the ticker node.
  document.addEventListener('shopify:section:load', function (e) {
    initTicker(e.target);
  });
})();
